import { FREE, ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { ProductToIconMap } from './ProductToIconMap';
export const HighlightedProductsHeaderConfig = {
  [MARKETING]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.marketing'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      subtitle: 'merchCards.starterCard.description.marketing',
      icon: ProductToIconMap[MARKETING][STARTER],
      includes: `pricing-pages.products.marketing-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      subtitle: 'merchCards.professionalCard.description.marketing',
      icon: ProductToIconMap[MARKETING][PROFESSIONAL],
      includes: `pricing-pages.products.marketing-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      subtitle: 'merchCards.enterpriseCard.description.marketing',
      icon: ProductToIconMap[MARKETING][ENTERPRISE],
      includes: `pricing-pages.products.marketing-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SALES]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.sales'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      subtitle: 'merchCards.starterCard.description.sales',
      icon: ProductToIconMap[SALES][STARTER],
      includes: `pricing-pages.products.sales-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      subtitle: 'merchCards.professionalCard.description.sales',
      icon: ProductToIconMap[SALES][PROFESSIONAL],
      includes: `pricing-pages.products.sales-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      subtitle: 'merchCards.enterpriseCard.description.sales',
      icon: ProductToIconMap[SALES][ENTERPRISE],
      includes: `pricing-pages.products.sales-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SERVICE]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.service'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      subtitle: 'merchCards.starterCard.description.service',
      icon: ProductToIconMap[SERVICE][STARTER],
      includes: `pricing-pages.products.service-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      subtitle: 'merchCards.professionalCard.description.service',
      icon: ProductToIconMap[SERVICE][PROFESSIONAL],
      includes: `pricing-pages.products.service-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      subtitle: 'merchCards.enterpriseCard.description.service',
      icon: ProductToIconMap[SERVICE][ENTERPRISE],
      includes: `pricing-pages.products.service-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [CMS]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.cms'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      subtitle: 'merchCards.starterCard.description.cms',
      icon: ProductToIconMap[CMS][STARTER],
      lowerTierPlus: 'pricing-pages.hubTiers.starter.includes'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      subtitle: 'merchCards.professionalCard.description.cms',
      icon: ProductToIconMap[CMS][PROFESSIONAL],
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      subtitle: 'merchCards.enterpriseCard.description.cms',
      icon: ProductToIconMap[CMS][ENTERPRISE],
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [OPERATIONS]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.operations'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      subtitle: 'merchCards.starterCard.description.operations',
      icon: ProductToIconMap[OPERATIONS][STARTER],
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      subtitle: 'merchCards.professionalCard.description.operations',
      icon: ProductToIconMap[OPERATIONS][PROFESSIONAL],
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      subtitle: 'merchCards.enterpriseCard.description.operations',
      icon: ProductToIconMap[OPERATIONS][ENTERPRISE],
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  }
};